export const SOURCE_OF_WEALTH_OPTIONS = [
  { value: 1, label: "Investment" },
  { value: 2, label: "Pension" },
  { value: 3, label: "Property Income" },
  { value: 4, label: "Inheritance" },
  { value: 5, label: "Family or Spousal Income" },
  { value: 6, label: "Employment" },
  { value: 7, label: "Savings from Employment" },
  { value: 8, label: "Retirement Provision" },
  { value: 9, label: "Rental / Property Sale" },
  { value: 10, label: "Company Ownership / Profits" },
  { value: 11, label: "Loan" },
  { value: 12, label: "Dividends / Interests" },
  { value: 13, label: "Insurance Proceeds" },
  { value: 14, label: "Investment Proceeds" },
  { value: 15, label: "Gift" },
  { value: 16, label: "Lottery / Betting / Casino Win" },
  { value: 17, label: "Other" },
];

export const DEPOSIT_METHOD_OPTIONS = [
  { value: 1, label: "Wire Transfer" },
  { value: 2, label: "Cards" },
  { value: 3, label: "E-Wallets" },
  { value: 4, label: "Other" },
];

export const CORPORATE_SOURCE_OF_WEALTH_OPTIONS = [
  { value: 1, label: "Company Ownership / Profits" },
  { value: 2, label: "Company Loan" },
  { value: 3, label: "Property Sale" },
  { value: 4, label: "Other" },
];

export const CRS_CLASSIFICATION_OPTIONS = [
  {
    value: 1,
    label: "Passive NFE with Controlling Reportable Person",
  },
  { value: 2, label: "CRS Reportable Person" },
  { value: 3, label: "Passive NFE that is CRS Reportable Person" },
  { value: 4, label: "Financial Institution" },
  { value: 5, label: "Active NFE" },
];

export const SOURCE_OF_WEALTH_OTHER = 17;
export const DEPOSIT_METHOD_OTHER = 4;
export const CORPORATE_SOURCE_OF_WEALTH_OTHER = 4;
export const CRS_PASSIVE_NFE_WITH_CONTROLLING = 1;

export const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || "";
